import { render } from "./ChulhaAssignMod.vue?vue&type=template&id=f37eaea8&scoped=true"
import script from "./ChulhaAssignMod.vue?vue&type=script&lang=js"
export * from "./ChulhaAssignMod.vue?vue&type=script&lang=js"

import "./ChulhaAssignMod.vue?vue&type=style&index=0&id=f37eaea8&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-f37eaea8"

export default script